<script setup lang="ts">
import useNetworkStore from '~/store/network'

const networkStore = useNetworkStore()

export interface Props {
    compatiblePrefix: string
}

withDefaults(defineProps<Props>(), {
    compatiblePrefix: ''
})
</script>

<template>
    <div
        class="px-4 py-6 flex-col justify-center items-center gap-4 inline-flex"
    >
        <img
            alt="Chargemap"
            class="w-32 h-24"
            :src="`${useRuntimeConfig().app.cdnURL}/images/ChargemapCardBusiness.svg`"
        />
        <div class="max-w-80 text-center">
            <span
                class="text-zinc-800 text-xl font-bold font-jakarta leading-tight"
            >
                <i18n-t
                    scope="global"
                    :keypath="`networks.cta_charge.${compatiblePrefix}.1`"
                >
                    <template #network>
                        <span class="uppercase text-sky-500">
                            {{ networkStore.name }}
                        </span>
                    </template>
                </i18n-t>
            </span>
            <br />
            <span
                class="text-zinc-800 text-base font-medium font-inter leading-normal"
            >
                <i18n-t
                    scope="global"
                    :keypath="`networks.cta_charge.${compatiblePrefix}.2`"
                >
                    <template #thousandNetworks>
                        <span class="text-sky-500">
                            {{ $t('networks.cta_charge.thousand_networks') }}
                        </span>
                    </template>
                </i18n-t>
            </span>
        </div>
        <a
            href="/pass/purchase/step1"
            class="w-full max-w-72"
            :title="$t('order.order_now')"
        >
            <ChargemapB2CButton type="primary" class="w-full">
                {{ $t('order.order_now') }}
            </ChargemapB2CButton>
        </a>
    </div>
</template>
